export enum RowTypes {
    ROW = 'Row',
    ROW_TOTAL = 'RowTotal',
    HEADER_ROW = 'HeaderRow',
    EMPTY_ROW = 'EmptyRow',
    SUB_ROW = 'SubRow',
    OF_THAT = 'Of',
    ACCOUNT = 'Acc',
    GROUP_HEADER = 'GroupHeader',
    GROUP_TOTAL = 'GroupTotal',
    SUB_TOTAL = 'SubTotal',
    TABLE_TOTAL = 'TableTotal',
    TABLE_HEAD = 'TableHead',
    OPTIONAL_ROW = 'OptRow',
    CALC_ROW = 'CalcRow',
    TITLE_ROW = 'TitleRow',
    FOOTNOTE = 'Footnote',
}
